<template>
    <div class="content-top mx-2 lg:mx-0 pr-1 sm:pr-6">
        <Head title="Wallet" />

        <heading>
            <template #heading>
                <div class="flex justify-between items-center w-full">
                    <div>Wallet</div>
                    <div class="flex justify-center items-center gap-3">
                        <span class="hidden sm:block text-red-700 text-sm font-normal" v-if="!hasPayoutMethod">Your payout method has not been updated.</span>
                        <jet-button :color="hasPayoutMethod ? 'brand' : 'red'" size="sm" @click.native="$root.$emit('showUpdatePayoutMethodModal')">Update Payout Details</jet-button>
                    </div>
                </div>
                <div class="sm:hidden text-red-700 text-sm font-normal mt-3 text-center" v-if="!hasPayoutMethod">Your payout method has not been updated.</div>
            </template>
        </heading>
        <div class="lg:col-span-8">
            <div class="grid sm:gap-5 grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 rounded-lg shadow overflow-hidden md:shadow-none sm:overflow-visible">
                <div class="flex flex-row justify-between px-5 py-3 bg-white dark:bg-slate-800 overflow-hidden sm:rounded-lg sm:shadow">
                    <div class="flex flex-col items-center">
                        <dl>
                            <dt class="text-gray-500 dark:text-gray-400 text-md font-medium truncate">Token Balance</dt>
                            <dd>
                                <div class="text-gray-900 dark:text-slate-300 text-4xl font-medium">
                                    {{ wallet.balance | toLocaleString }}
                                </div>
                            </dd>
                        </dl>
                    </div>
                    <div>
                        <jet-button size="sm" @click.native="$root.$emit('showBuyTokensModal')">Buy Tokens</jet-button>
                    </div>
                </div>
                <div class="flex flex-col sm:flex-row justify-between px-5 py-3 gap-4 sm:gap-0 bg-white dark:bg-slate-800 overflow-hidden sm:rounded-lg sm:shadow col-span-2">
                    <div class="flex flex-col sm:border-r border-gray-200 dark:border-slate-900 flex-grow">
                        <dl>
                            <dt class="text-gray-500 dark:text-gray-400 text-md font-medium truncate">Available Earnings</dt>
                            <dd>
                                <div class="text-gray-900 dark:text-slate-300 text-4xl font-medium">${{ totalUnpaid }}</div>
                            </dd>
                        </dl>
                    </div>

                    <div class="flex flex-col sm:border-r border-gray-200 dark:border-slate-900 flex-grow sm:pl-5">
                        <dl>
                            <dt class="text-gray-500 dark:text-gray-400 text-md font-medium truncate">Paid Earnings</dt>
                            <dd>
                                <div class="text-gray-900 dark:text-slate-300 text-4xl font-medium">${{ totalPaid }}</div>
                            </dd>
                        </dl>
                    </div>

                    <div class="flex flex-col flex-grow sm:pl-5">
                        <dl>
                            <dt class="text-gray-500 dark:text-gray-400 text-md font-medium truncate">Total Earnings</dt>
                            <dd>
                                <div class="text-gray-900 dark:text-slate-300 text-4xl font-medium">${{ total }}</div>
                            </dd>
                        </dl>
                    </div>
                </div>
            </div>

            <recent-token-activity :activity="tokenActivity" class="mt-8" />
        </div>
    </div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout"
import Heading from "@/Components/Heading"
import Pagination from "@/Components/Pagination"
import RecentTokenActivity from "@/Components/Wallet/RecentTokenActivity"
import JetButton from "@/Jetstream/Button"

export default {
    name: "Wallet",

    components: { JetButton, RecentTokenActivity, Pagination, Heading },

    layout: AppLayout,

    mounted() {
        if (this.modal === "payout-method") {
            this.$root.$emit("showUpdatePayoutMethodModal")
        }
    },

    computed: {
        hasPayoutMethod() {
            return !!this.$page.props.user.payoutMethod
        },
        total() {
            return this.commissions ? this.commissions.total : this.payouts.total
        },
        totalUnpaid() {
            return this.commissions ? this.commissions.totalUnpaid : this.payouts.totalUnpaid
        },
        totalPaid() {
            return this.commissions ? this.commissions.totalPaid : this.payouts.totalPaid
        },
    },

    props: {
        wallet: Object,
        payouts: Object,
        commissions: Object,
        tokenActivity: Object,
        pledgesCount: Number,
        modal: String,
    },

    data() {
        return {
            showBuyTokensModal: false,
            showUpdatePayoutDetailsModal: false,
        }
    },
}
</script>
